'use client'

import { useSalaryFilters } from '@/modules/salary/filters/use-salary-filters'
import {
  SeoLinkGroup,
  SeoLink as SeoLinkT,
} from '@/lib/generated/graphql-types'
import { formatJobType } from '@/modules/salary/common/utils'
import { Link } from '@/components/ui/link'
import { handleSeoLinkClick } from './utils'
import { SeoLinkGroupType } from './constants'

export function SeoLink({
  link,
  salaryUrl,
  isAuthenticated,
  group,
}: {
  link: SeoLinkT
  salaryUrl: string
  isAuthenticated: boolean
  group: SeoLinkGroup
}) {
  const { updateSalaryFilters } = useSalaryFilters({
    isAuthenticated,
  })
  const handleClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    handleSeoLinkClick({ evt, link, updateSalaryFilters })
  }
  return (
    <Link
      href={salaryUrl}
      variant="mutedLink"
      isExternal={false}
      onClick={handleClick}
    >
      {group.groupType === SeoLinkGroupType.jobType
        ? formatJobType(link.jobType)
        : null}
      {group.groupType === SeoLinkGroupType.location ? link.state?.name : null}
      {group.groupType === SeoLinkGroupType.specialty
        ? link.occupation?.specialty?.fullName
        : null}
    </Link>
  )
}
